/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {deleteLocalStorage} from '@ion/core/src/capabilities/storage';
import {error as logger} from '@ion/core/src/logger/logger';
import {setArcGISErrorHandler} from '@ion/core/src/services/ArcGISUtils';
import {setSDConnectErrorHandler} from '@ion/core/src/services/SDConnectUtils';
import {ServiceError} from '@ion/core/src/types/services';
import {getRoute, Route} from '@/routes/RouteDefinitions';
import {ApplicationKeys} from '@/types/application';

export const SERVICE_ERROR         = 'SERVICE_ERROR';
export const SERVICE_ERROR_RETRY   = 'SERVICE_ERROR_RETRY';
export const SERVICE_ERROR_DISMISS = 'SERVICE_ERROR_DISMISS';

/**
 * Provides the initialization hook for adding global error interceptors.
 */
export const addErrorInterceptor = dispatch => {
  const interceptor = (error: ServiceError) => {
    dispatch(serviceError(error));
    logger(`BMW Portal Service Error [${error.status || 'N/A'}]`);
    return Promise.reject(error);
  };
  setSDConnectErrorHandler(interceptor);
  setArcGISErrorHandler(interceptor);
};

/**
 * Dispatched when a global service error occurs in iOn, at which point the
 * error reducer state is updated and the user is notified of the error.
 */
export const serviceError = (error?: ServiceError) => {
  return {type: SERVICE_ERROR, error};
};

/**
 * Dispatched when a user chooses to retry a the operation which causes the global
 * service error to occur.
 */
export const retry = () => {
  return {type: SERVICE_ERROR_RETRY};
};

/**
 * Dispatched when the user chooses to dismiss a global service error notification.
 */
export const dismiss = () => {
  return {type: SERVICE_ERROR_DISMISS};
};

/**
 * Dispatched when the user chooses to log back in after being notified that their
 * session has expired.
 */
export const restart = () => {
  return async() => {
    deleteLocalStorage(ApplicationKeys.BMWPortalSession);
    location.assign(getRoute(Route.LOGIN));
  };
};
